<template>
  <v-card class="project-details-card">
    <p class="project-details-card__line">
      ID projektu: <b>{{ project.id }}</b>
    </p>
    <p
      v-if="project.createdAt"
      class="project-details-card__line"
    >
      Data rozpoczęcia: <b>{{ project.createdAt | displayDate }}</b>
    </p>
    <p
      v-if="project.start_date"
      class="project-details-card__line"
    >
      Data zakończenia: <b>{{ project.endDate | displayDate }}</b>
    </p>
    <p
      v-if="project.deadline"
      class="project-details-card__line"
    >
      Termin wykonania: <b>{{ project.deadline | displayDate }}</b>
    </p>
    <p
      v-if="project.projectType"
      class="project-details-card__line"
    >
      Typ projektu: <b>{{ project.projectType }}</b>
    </p>
    <p class="project-details-card__line">
      Media: <b>{{ joinedMedia }}</b>
    </p>
    <p
      v-if="project.priority"
      class="project-details-card__line"
    >
      Priorytet: <b :class="[`priority--${priorityColor}`]">{{ project.priority }}</b>
    </p>
    <p class="project-details-card__line">
      Do druku: <b>{{ project.printCoordination ? 'Tak' : 'Nie' }}</b>
    </p>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AppCopyUrl from '@/components/UI/AppCopyUrl.vue';

export default {
  components: {
    AppCopyUrl,
  },

  props: {
    project: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState({
      projectPriorities: (state) => state.filters.filtersOptions.projectPriorities,
    }),

    ...mapGetters('auth', ['checkUserPermissions']),

    joinedMedia() {
      return this.project.media?.map((medium) => medium.name).join(', ') || 'Brak';
    },

    statusChangePermitted() {
      const availability = ['admin_director', 'chief'];
      return this.checkUserPermissions(availability);
    },

    priorityColor() {
      const colors = ['green', 'blue', 'orange', 'red'];
      const index = this.projectPriorities?.findIndex(
        (priority) => priority === this.project.priority,
      );
      return colors[index || 0];
    },
  },
};
</script>

<style lang="scss" scoped>
.project-details-card {
  padding: 20px 32px;

  &__title {
    font-size: 15px;
  }

  &__line {
    line-height: 24px;
  }
}

.priority {
  &--red {
    color: #e25b46;
  }
  &--orange {
    color: #ea9e36;
  }
  &--blue {
    color: $primary;
  }
  &--green {
    color: #00695f;
  }
}
</style>
